import {UI} from "../../../../../stem-core/ui/UIBase";
import {UserDashboardSection} from "../components/UserDashboardSection.jsx";
import {UserDashboardTab, UserDashboardTabStyle} from "./UserDashboardTab.jsx";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService.js";
import {Messages} from "../../../../Messages.js";
import {userService} from "../../../../../client/connection/services/UserService.js";
import {CheckboxInput} from "../../../../../stem-core/ui/input/checkbox/CheckboxInput.jsx";
import {
    apiUserUpdateNewsletterSubscriptions,
    MerchantAudienceMember,
    NewsletterSubscriptionUpdateType
} from "../../../../../client/state/merchant/MerchantAudienceMemberStore.js";
import {registerStyle} from "../../../../../stem-core/ui/style/Theme";
import {styleRule} from "../../../../../stem-core/decorators/Style";
import {wrapInSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {MessageElement} from "../../../../widget/ui/MessageElement.jsx";
import {MerchantUser} from "../../../../../client/state/merchant/MerchantUserStore.js";
import {MerchantAudience} from "../../../../../client/state/merchant/MerchantAudienceStore.js";
import {Toast} from "../../../../ui/Toast.jsx";
import {autoredraw} from "../../../../../stem-core/decorators/AutoRedraw";
import {Flow} from "../../../flows/Flow.js";


class UserDashboardNewslettersTabStyle extends UserDashboardTabStyle {
    @styleRule
    checkboxesList = {
        padding: "16px 0",
    };

    @styleRule
    separatorLine = {
        width: "100%",
        height: 0.5,
        background: "#E5E5E5",
    };

    @styleRule
    message = {
        marginTop: 16,
    };
}

@autoredraw(MerchantAudienceMember)
@registerStyle(UserDashboardNewslettersTabStyle)
export class UserDashboardNewslettersTab extends UserDashboardTab {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.newslettersTitle,
        }
    }

    @wrapInSpinner
    async update(newsletterIds = [], updateType = NewsletterSubscriptionUpdateType.SUBSCRIBE) {
        const emailAddress = userService.getUserEmail();
        const {merchantId} = iFrameMerchantService;
        const merchantUser = MerchantUser.getByUserAndMerchant(userService.getUserId(), merchantId);

        const request = {
            emailAddress, // TODO this should be the userId if we're authenticated
            merchantId,
            newsletterIds,
            updateType,
        };

        const canReceivePromotionalEmails = this.promotionalEmailsCheckbox.getValue();

        if (canReceivePromotionalEmails !== merchantUser.canReceivePromotionalEmails) {
            request.canReceivePromotionalEmails = canReceivePromotionalEmails;
        }

        await apiUserUpdateNewsletterSubscriptions(request);

        Toast.showSuccess(Messages.changesSaved);
    }

    render() {
        const {styleSheet} = this;
        const newsletters = Flow.newsletter.getNewsletters();
        const merchantName = iFrameMerchantService.getMerchant().name;
        const merchantUser = MerchantUser.getByUserAndMerchant(userService.getUserId(), iFrameMerchantService.merchantId);

        const individualNewsletterCheckboxes = newsletters.map(audience => <CheckboxInput
            label={audience.name}
            onChange={enabled => this.update([audience.id], enabled ? NewsletterSubscriptionUpdateType.SUBSCRIBE : NewsletterSubscriptionUpdateType.UNSUBSCRIBE)}
            initialValue={MerchantAudienceMember.find(member => member.isSubscribed() && member.audience === audience) != null}
            className={styleSheet.textSection}
        />);

        return <UserDashboardSection titleMessage={<MessageElement message={Messages.signUpForMerchantNewsletter} args={[merchantName]}/>}>
            <MessageElement
                message={Messages.newslettersEditDescription(userService.getUserEmail())}
            />
            <div className={styleSheet.checkboxesList}>
                {individualNewsletterCheckboxes}
                {individualNewsletterCheckboxes.length > 0 && <div className={styleSheet.separatorLine}/>}
                <CheckboxInput
                    ref="promotionalEmailsCheckbox"
                    label={Messages.allowPromotionalEmailsFromMerchant(merchantName)}
                    className={styleSheet.textSection}
                    onChange={() => this.update()}
                    initialValue={!merchantUser || merchantUser.canReceivePromotionalEmails}
                />
            </div>
            <MessageElement
                message={Messages.newsletterDashboardEmailDescription(userService.getUserEmail())}
                className={styleSheet.message}
            />
        </UserDashboardSection>
    }
}
